import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './core/services/store';
import ApiService from './core/services/api.service';
import { VERIFY_AUTH } from './core/services/store/modules/auth.module';
import { RESET_LAYOUT_CONFIG } from '@/core/services/store/modules/config.module';

import UUID from 'vue-uuid';
import VueAutosuggest from 'vue-autosuggest';
import VueMask from 'v-mask';
import NProgress from 'vue-nprogress';
import VueClipboard from 'vue-clipboard2';
import SweetAlertPlugin from './core/plugins/sweet-alert2';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import '@/view/base/_globals';
import SaveButton from '@/view/components/common/SaveButton.vue';
Vue.component('SaveButton', SaveButton);

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.config.productionTip = false;

Vue.use(UUID);
Vue.use(VueAutosuggest);
Vue.use(VueMask);
Vue.use(NProgress);
Vue.use(SweetAlertPlugin);

import 'popper.js';
import 'tooltip.js';
import PerfectScrollbar from 'perfect-scrollbar';
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from 'clipboard';
import VueUploadComponent from 'vue-upload-component';
window.ClipboardJS = ClipboardJS;
const nprogress = new NProgress();
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.component('file-upload', VueUploadComponent);

import ResizableColumns from '@/directives/ResizableColumns';
Vue.directive('resizable-columns', ResizableColumns);

import EllipsisTooltip from '@/directives/ellipsisTooltip';
Vue.directive('ellipsis-tooltip', EllipsisTooltip);

// Vue 3rd party plugins
import i18n from './core/plugins/vue-i18n';
import vuetify from './core/plugins/vuetify';
import './core/plugins/portal-vue';
import './core/plugins/bootstrap-vue';
import './core/plugins/perfect-scrollbar';
import './core/plugins/inline-svg';
import './core/plugins/metronic';
import './core/plugins/datepicker';
import '@mdi/font/css/materialdesignicons.css';
ApiService.init();

router.beforeEach((to, from, next) => {
  store.dispatch(RESET_LAYOUT_CONFIG);

  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

Vue.config.errorHandler = function(err) {
  console.log('errorHandler', err);
  nprogress.done();
};

Vue.directive('focus', {
  inserted: function(el) {
    el.focus();
  },
  update: function(el, binding) {
    var value = binding.value;
    if (value) {
      Vue.nextTick(function() {
        el.focus();
      });
    }
  },
});

new Vue({
  router,
  store,
  i18n,
  nprogress,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
